module.exports = __webpack_public_path__ + "img/rajiv.7e5e809c.jpg";